"use client";

import HlsVideoPlayer from "@/components/common/HlsVideoPlayer";

/**
 * Hero video for the Elite Fitness Transformation page.
 *
 * Served as HLS from R2 via the cloudflare-r2-hls pipeline. The original
 * Publitio stream is not playable outside Publitio's own embed (their AES
 * key server rejects out-of-player requests), so this asset moved to R2.
 */
const EFT_HLS_SRC =
  "https://course-media.comunidad.fit/videos/landing/elite-fitness-transformation-hero/master.m3u8";
const EFT_POSTER =
  "https://general-media.comunidad.fit/landing/elite-fitness-transformation-hero.jpg";

export function EliteHeroVideo({ className }: { className?: string }) {
  return (
    <HlsVideoPlayer src={EFT_HLS_SRC} poster={EFT_POSTER} className={className} />
  );
}
